module.exports = __webpack_public_path__ + "/images/logo-hellobb-dark.bb8f064.svg";